import { render, staticRenderFns } from "./Check.vue?vue&type=template&id=5fdac75f"
import script from "./Check.js?vue&type=script&lang=js&external"
export * from "./Check.js?vue&type=script&lang=js&external"
import style0 from "./Check.vue?vue&type=style&index=0&id=5fdac75f&prod&lang=scss&scopedSlots=true&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports